"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconWrapper = exports.StyledFilterIconSection = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
exports.StyledFilterIconSection = components_core_1.styled.div `
  @media (min-width: ${components_core_1.Breakpoints.b960}px) {
    display: none;
  }
`;
exports.StyledIconWrapper = components_core_1.styled.div `
  display: flex;
  align-items: center;
  border-radius: 22px;
  border: solid 1px #001e50;
  padding: 7px 12px;
  margin: 3px 0 2px;

  svg {
    margin-right: 5px;
  }
`;
